import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export class CustomLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);

  private readonly cacheVersion = '74648938';

  /** Cache to prevent duplicate concurrent requests and retry loops for the same language */
  private readonly translationCache = new Map<string, Observable<any>>();

  public getTranslation(lang: string): Observable<any> {
    const cached = this.translationCache.get(lang);
    if (cached) {
      return cached;
    }

    const url = `/assets/i18n/${lang}.json?v=${this.cacheVersion}`;
    const request$ = this.http.get(url).pipe(
      catchError(() => of({})),
      shareReplay({ bufferSize: 1, refCount: false })
    );

    this.translationCache.set(lang, request$);
    return request$;
  }
}
